import { registerQuery } from 'data-fetching-client';
import { getFeaturedCallouts } from '../../clients/qualityClient';
export const GET_FEATURED_CALLOUTS_QUERY = registerQuery({
  fieldName: 'featuredCallouts',
  args: ['appContext', 'offeringType'],
  fetcher: getFeaturedCallouts
});